import StoreOrderSummary, { RegistryDiscount } from './store-order-summary'

export { StoreOrderSummary as default, RegistryDiscount }
